<template>
    <div class="item-inner">
      <div class="head">
        <div class="treerow lvl3" v-on:click="$set(source,'expanded', !source.expanded)">
          <hsc-menu-context-menu class="menucontainer">
            <span :class=" 'db' + (source.expanded? ' expanded' : ' collapsed')">{{ source.tablename }}</span>            
            <div slot="contextmenu" style="z-index:8">
              <hsc-menu-item label="Select top 1000" v-on:click.native.stop="SelectTop1000()" />
              <hsc-menu-item label="Modify structure" v-on:click.native.stop="EditTable(db)" /> 
              <hsc-menu-item label="Create table" v-on:click.native.stop="ScriptCreateTbl()" />
              <hsc-menu-item label="Delete" v-on:click.native.stop="DeleteTable()" />
            </div>
          </hsc-menu-context-menu>
        </div>
        <div v-if="source.expanded">
          <div>
            <div class="treerow lvl4" v-on:click="$set(source,'expanded_columns', !source.expanded_columns)">
              <span :class="'db'+(source.expanded_columns?' expanded' :' collapsed')">Columns ({{source.fields.length}})</span>
            </div>
            <!-- <div v-if="tbl.expanded_columns" ref="lvl4Scroll" :class="tbl.fields.length>9 ? 'lvl4Scroll' : ''" @mouseover.stop="scrollVisible('lvl4Scroll')" @mouseleave.stop="scrollNone('lvl4Scroll')"> -->
            <div v-if="source.expanded_columns" >
              <div v-for="fld in source.fields" v-bind:key="fld.name" class="treerow lvl5">
                <!--<span class="db">{{fld.name}}</span><span class="db otherinfo"> [{{typemap[fld.type+'-'+fld.subtype]+ typePrecision(fld) +','+(fld.nullable === 1?'':' NOT')+' NULL'||(fld.type+'-'+fld.subtype)}}]{{' ' + fld.linktable}}</span> -->
                <span class="db">{{fld.name}}</span><span class="db otherinfo"> {{ typePrecision(fld) }}</span>
              </div>
            </div>
          </div>
          <div>
            <div v-on:click="$set(source,'expanded_indices', !source.expanded_indices)">  
              <div class="treerow lvl4">
                <hsc-menu-context-menu class="menucontainer">                  
                  <span :class="'db'+(source.expanded_indices?' expanded' :' collapsed')">Indices ({{GetIndexListForTable(source.tablename).length}})</span>
                  <div slot="contextmenu" style="z-index:8">
                    <hsc-menu-item label="Create" v-on:click="OpenCreateIndexDialog()" />
                  </div>
                </hsc-menu-context-menu>
              </div>                     
              <div v-if="source.expanded_indices">
                <div v-for="idx in GetIndexListForTable(source.tablename)" v-bind:key="idx.name + source.tablename" >
                  <!-- GETINDEXLISTFORTABLE(source.port, source.tablename) -->
                  <div class="treerow lvl5" v-on:click.stop="$set(idx,'expanded', !idx.expanded)">                 
                    <hsc-menu-context-menu class="menucontainer">
                      <span :class="'db'+(idx.expanded?' expanded' :' collapsed')">{{idx.name}}</span><span v-if="idx.uniq && idx.uniq == 1" class="otherinfo"> [{{'uniq'}}]</span>
                      <div slot="contextmenu" style="z-index:8">
                        <hsc-menu-item label="Delete" v-on:click="DeleteIndex(idx)" />
                      </div>
                    </hsc-menu-context-menu>
                  </div>
                  <div v-if="idx.expanded" v-bind:key="idx.name">
                    <div v-for="(fld, index) in idx.fields" v-bind:key="index" @contextmenu.prevent="" class="treerow lvl6">
                      <span class="db">{{fld}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
    
  <script>
    import {commonMixin} from '../../common.js'
    export default {
      name: 'dynamic-size-item',
      mixins: [commonMixin],
      props: {
        source: {
          type: Object,
          default () {
            return {
            }
          }
        },
        db: {
          type: Object,
        }
      },
      data() {
        return {
          typemap: {
            "1-1": "varchar", //PK
            "1-0": "varchar",
            "1-2": "varchar", //FK
            "2-0": "int",
            "2-1": "int", //PK
            "2-2": "int", //FK
            "3-0": "bigint",
            "3-1": "bigint", //PK
            "3-2": "bigint", //FK
            "4-0": "double",
            "4-1": "double", //PK
            "4-2": "double", //FK
            "5-0": "datetime",
            "5-1": "datetime", //PK
            "5-2": "datetime", //FK
            "6-0": "bit",
            "7-0": "date",
            "7-1": "date", //PK
            "7-2": "date", //FK
            "9-0": "varbinary",
            "9-1": "varbinary", //PK
            "9-2": "varbinary", //FK
            "10-0": "nvarchar",
            "10-1": "nvarchar",
            "10-2": "nvarchar",
            "11-0": "rowversion",
            "11-1": "rowversion",
            "11-2": "rowversion",
            "12-0": "decimal",
            "12-1": "decimal",
            "12-2": "decimal",
          },
        }
      },
      methods: {        
        GetIndexListForTable(table){
          var idxlist = [];
          idxlist = this.db.indexes.filter(i => i.table == table)
          return idxlist;
        },
        typePrecision(fld) {  
          let val = ''
          let type = this.typemap[fld.type+'-'+fld.subtype]
          
          if (fld.precision != 0 && fld.precision != -1) {
            switch (fld.type) {
              case 12:
                val = ` (${fld.precision},${fld.scale}) `
                break;
                
              case 5:
                type = 'datetime'
                val = ` (${fld.precision}) `
                break;
  
              default:
                val = ` (${fld.precision}) `
                break;
            }        
          } else if (fld.precision == -1) {
            val =` (max) `
          } 
          let str =  '[' + type + val +','+(fld.nullable === 1?'':' NOT')+' NULL]'||(fld.type+'-'+fld.subtype) + ']' + ' ' + fld.linktable 
          // console.log('typePrec str ', str);  
          return str
        },
        SelectTop1000(){
          // console.log('SelectTop1000');
          let select = "SELECT TOP 1000 * FROM " + '['+this.source.tablename+']' + ";";
          this.dispatch('App','select1000',select)
        },
        EditTable(db) {
          console.log('EditTable');
          let newtab = {
            name: 'Create table',
            active: true,
            type: 'edit-table',
            db: db,
            table:this.source,
            resulttext:'',
            status:'',
            timespent:-1,
            idconnect: null
          };
          this.dispatch('App','editTable',newtab)
        },
        ScriptCreateTbl() {
          console.log('ScriptCreateTbl');
          this.dispatch('App','createTbl',this.source)
        },
        DeleteTable() {
          console.log('DeleteTable');
          this.dispatch('App','deleteTable',this.db,this.source)
        },
        OpenCreateIndexDialog() {
          console.log('OpenCreateIndexDialog');
          this.dispatch('App','createIndex',this.db,this.source)
        },
        DeleteIndex(idx) {
          console.log('DeleteIndex',idx);
          this.dispatch('App','deleteIndex',this.db,idx)
        }
      }
    }
  </script>
  
  <style scoped>
    .db{
      cursor: pointer;
      overflow-x: hidden;
    }
    .collapsed::before{
      content: "+";
      display: inline-block;
      font-style: normal;
      font-size: 15px;
      font-weight: 900;
      color: #326690;
      margin-right: 5px;
      width: 8px;
    }
    .expanded::before{
      transform: rotate(0deg);
      content: "-";
      display: inline-block;
      font-style: normal;
      font-size: 15px;
      font-weight: 900;
      color: #326690;
      margin-right: 5px;
      width: 8px;
    }
  </style>
  